import { render, staticRenderFns } from "./invoice-status-badge.vue?vue&type=template&id=bc1d73e6&scoped=true"
import script from "./invoice-status-badge.vue?vue&type=script&lang=js"
export * from "./invoice-status-badge.vue?vue&type=script&lang=js"
import style0 from "./invoice-status-badge.vue?vue&type=style&index=0&id=bc1d73e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1d73e6",
  null
  
)

export default component.exports